var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-form",
                {
                  ref: "myForm",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.handleSubmit($event)
                    }
                  }
                },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary", fixed: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm12: "", layout: "", "align-center": "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                layout: "",
                                "align-center": "",
                                wrap: "",
                                "align-start": ""
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", dark: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClosed({})
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { color: "white" } }, [
                                    _vm._v("close")
                                  ])
                                ],
                                1
                              ),
                              _c("v-toolbar-title", [
                                _vm._v(
                                  "\n                Generar Movimiento\n              "
                                )
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-editar",
                                  attrs: {
                                    type: "submit",
                                    disabled: _vm.disabledBtn
                                  }
                                },
                                [_vm._v("Guardar Cambios")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _c("br"),
                  _c("br"),
                  _c("br"),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "cardnew", attrs: { align: "center" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md10: "", "pt-5": "" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "rounded-card" },
                              [
                                _c(
                                  "v-container",
                                  { attrs: { "grid-list-md": "" } },
                                  [
                                    _c(
                                      "div",
                                      { attrs: { align: "left" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "" } },
                                          [
                                            _c(
                                              "h2",
                                              { staticClass: "h2_title" },
                                              [_vm._v("Generar Movimiento")]
                                            ),
                                            _c("v-divider"),
                                            !_vm.loading
                                              ? _c(
                                                  "v-flex",
                                                  {
                                                    attrs: {
                                                      sm12: "",
                                                      layout: "",
                                                      wrap: "",
                                                      "pa-4": ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            value:
                                                              "Por Asignar",
                                                            label: "movimiento",
                                                            type: "text",
                                                            disabled: "",
                                                            "prepend-icon":
                                                              "123"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: "Usuario",
                                                            type: "text",
                                                            disabled: "",
                                                            "prepend-icon":
                                                              "person"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .usuario.nombre,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi
                                                                  .usuario,
                                                                "nombre",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.usuario.nombre"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            label: "Operación",
                                                            disabled: "",
                                                            items:
                                                              _vm.listApi
                                                                .operaciones,
                                                            "item-value":
                                                              "operacion_id",
                                                            "item-text":
                                                              "operacion_name",
                                                            "prepend-icon":
                                                              "home_repair_service",
                                                            "return-object": ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .operacion,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "operacion",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.operacion"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            label: "Origen",
                                                            disabled: "",
                                                            "prepend-icon":
                                                              "departure_board",
                                                            items:
                                                              _vm.listApi
                                                                .destinos,
                                                            "item-value":
                                                              "tipoubicaid",
                                                            "item-text":
                                                              "tipoubicaname",
                                                            "return-object": ""
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChange
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .origen,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "origen",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.origen"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            label:
                                                              "Destino (Obligatorio)",
                                                            "prepend-icon":
                                                              "flag",
                                                            items:
                                                              _vm.listApi
                                                                .destinosDisponibles,
                                                            rules: [
                                                              _vm.rules.destino
                                                            ],
                                                            "item-value":
                                                              "tipoubicaid",
                                                            required: "",
                                                            "item-text":
                                                              "tipoubicaname",
                                                            "return-object": ""
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChange
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .destino,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "destino",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.destino"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            label:
                                                              "Número Orden Despacho",
                                                            "prepend-icon":
                                                              "123",
                                                            items:
                                                              _vm.listApi
                                                                .numDespachos,
                                                            "item-value":
                                                              "despanumero",
                                                            "item-text":
                                                              "despaseguimiento",
                                                            "return-object": ""
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChange
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .numDespacho,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "numDespacho",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.numDespacho"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label:
                                                              "Caja Número",
                                                            type: "text",
                                                            "prepend-icon":
                                                              "123"
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChange
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .movicajanro,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "movicajanro",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.movicajanro"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm4: "" } },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            label:
                                                              "Estado (Obligatorio)",
                                                            "prepend-icon":
                                                              "update",
                                                            items:
                                                              _vm.listApi
                                                                .estados,
                                                            "item-value":
                                                              "estado_id",
                                                            "item-text":
                                                              "estado_name",
                                                            required: "",
                                                            "return-object": ""
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChange
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .estado,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "estado",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.estado"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { sm12: "" } },
                                                      [
                                                        _c("v-textarea", {
                                                          attrs: {
                                                            counter: "500",
                                                            label:
                                                              "Observación",
                                                            "prepend-icon":
                                                              "feedback",
                                                            rules: [
                                                              _vm.rules
                                                                .textareaCounter
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.paramApi
                                                                .moviobs,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.paramApi,
                                                                "moviobs",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "paramApi.moviobs"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("br")
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }